import {
  Tooltip,
  useMantineTheme,
  rem,
  Popover,
  Stack,
  Group,
  Text,
} from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { useState } from "react";
// import { InfoTooltipIcon } from "../../shared/svg/InfoTooltopIcon";

interface AITooltipProps {
  icon?: React.ReactNode;
  title: string;
  zIndex?: number;
}

export function AITooltip({ icon, title, zIndex = 1 }: AITooltipProps) {
  const theme = useMantineTheme();
  const isMobile = useMediaQuery("(pointer: coarse)");
  const [opened, setOpened] = useState(false);

  const tooltipContent = (
    <Stack gap={6} p={0}>
      <Group gap={6}>
        {/* <InfoTooltipIcon size={20} /> */}
        <Text span size="sm">
          {title}
        </Text>
      </Group>
    </Stack>
  );

  const tooltipStyles: React.CSSProperties = {
    backgroundColor: theme.colors.gray[1],
    color: theme.colors.dark[7],
    fontSize: rem(14),
    padding: `${rem(4)} ${rem(8)}`,
    borderRadius: rem(4),
    boxShadow: theme.shadows.sm,
    maxWidth: isMobile ? rem(300) : rem(500),
    wordWrap: "break-word" as "break-word",
    whiteSpace: "normal",
  };

  if (isMobile) {
    return (
      <Popover
        opened={opened}
        onChange={setOpened}
        withArrow
        offset={6}
        position="top"
        zIndex={zIndex}
        styles={{
          dropdown: tooltipStyles,
          arrow: { backgroundColor: theme.colors.violet[1] },
        }}
      >
        <Popover.Target>
          <div
            onClick={(e) => {
              e.stopPropagation();
              if (isMobile) setOpened((o) => !o);
            }}
          >
            {icon}
          </div>
        </Popover.Target>
        <Popover.Dropdown>{tooltipContent}</Popover.Dropdown>
      </Popover>
    );
  }

  return (
    <Tooltip
      zIndex={zIndex}
      withArrow
      multiline
      position="top"
      offset={6}
      arrowSize={7}
      transitionProps={{ duration: 100, transition: "fade" }}
      styles={{
        tooltip: tooltipStyles,
      }}
      label={tooltipContent}
    >
      {icon}
    </Tooltip>
  );
}
